import { render, staticRenderFns } from "./QuilityRxCompensableDrilldown.vue?vue&type=template&id=28cc0d2e&scoped=true&"
import script from "./QuilityRxCompensableDrilldown.vue?vue&type=script&lang=js&"
export * from "./QuilityRxCompensableDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc0d2e",
  null
  
)

export default component.exports